import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function usePatientContact() {
  const [isLoading, setLoading] = useState(false);

  const fetchContact = useCallback((patientId) => {
    setLoading(true);
    return quarkusApi
      .get(`/patients/${patientId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setLoading(false));
  }, []);

  return { fetchContact, isLoading };
}
